"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SnackbarScreen=void 0;var t;(function(e){e.Cart="Cart",e.Catalogue="Catalogue",e.Checkout="Checkout",e.ProductPage="Product Page",e.StoreHome="Store Home"})(t||(exports.SnackbarScreen=t={}));
//# sourceMappingURL=SnackbarScreen.js.map
